import { StyleObject } from 'styletron-react';

export const listStyles = (horizontal: any) => {
    return {
        display: 'grid',
        gridAutoRows: 'max-content',
        boxSizing: 'border-box',
        minWidth: '350px',
        width: horizontal && '100%',
        gridGap: '10px',
        padding: '20px',
        paddingBottom: '0',
        margin: '10px',
        borderRadius: '5px',
        minHeight: '200px',
        transition: 'background-color 350ms ease',
        gridTemplateColumns: 'repeat(var(--columns, 1), 1fr)',
        gridAutoFlow: horizontal ? 'column' : 'row',
        overflow: 'auto',

        ':after': {
            content: '',
            height: '10px',
            gridColumnStart: 'span var(--columns, 1)',
        }
    } as StyleObject;
}
